import axios from 'axios';
import { configData } from '../../configData/configData';

export class FormGradimentoService {

    constructor() {
        this.apiUrl = configData.API_BASE + '/api/feedback';
        
        /*var token = localStorage.getItem('token');

        this.client = axios.create({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}` 
            }
        });*/
    }

    
    async getListaValutazioni() {
        try {
            const url = `${this.apiUrl}/getListaValutazioni`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });
            
            const response = await this.client.get(url);

            return response.data;
        } catch (error) {
            console.error('Errore durante il caricamento:', error);
            throw error;
        }
    }


    async initFiltriValutazioni() {
        try {
            const url = `${this.apiUrl}/initFiltriValutazioni`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            const response = await this.client.get(url);

            return response.data;
        } catch (error) {
            console.error('Errore:', error);
            throw error;
        }
    }
    
    async initFiltriValutazioni_partner() {
        try {
            const url = `${this.apiUrl}/initFiltriValutazioni_partner`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            const response = await this.client.get(url);

            return response.data;
        } catch (error) {
            console.error('Errore:', error);
            throw error;
        }
    }


    async getValutazioniIntermedie(progetto, sottoprogetto, nomeCognome) {
        try {
            const url = `${this.apiUrl}/getValutazioniIntermedie`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            // Preparo i parametri
            const params = {
                idProgetto: progetto || null,  // null sarà interpretato come "Tutti"
                idSottoProgetto: sottoprogetto || null, // null sarà interpretato come "Tutti"
                nomeCognome: nomeCognome.trim() || null
            };

            const response = await this.client.get(url, { params });

            return response.data;
        } catch (error) {
            console.error('Errore:', error);
            throw error;
        }
    }
    
    async getValutazioniIntermedie_partner(progetto, sottoprogetto, nomeCognome) {
        try {
            const url = `${this.apiUrl}/getValutazioniIntermedie_partner`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            // Preparo i parametri
            const params = {
                idProgetto: progetto || null,  // null sarà interpretato come "Tutti"
                idSottoProgetto: sottoprogetto || null, // null sarà interpretato come "Tutti"
                nomeCognome: nomeCognome.trim() || null
            };

            const response = await this.client.get(url, { params });

            return response.data;
        } catch (error) {
            console.error('Errore:', error);
            throw error;
        }
    }


    async caricaDatiIniziali() {
        try {
            const url = `${this.apiUrl}/initFormGradimento`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });
            
            const response = await this.client.get(url);

            return response.data;
        } catch (error) {
            console.error('Errore durante l\'init del form:', error);
            throw error;
        }
    }
    
    async getRiepilogoValutazione() {
        try {
            const url = `${this.apiUrl}/getRiepilogoValutazione/`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });
            
            const response = await this.client.get(url);

            return response.data;
        } catch (error) {
            console.error('Errore durante l\'init del form:', error);
            throw error;
        }
    }
    
    async inviaAvvisoDisponibilitaValutazione(idProgetto, idSottoProgetto, listaUtenti) {
        /*if (!feedbackDTO.isValid()) {
            return Promise.reject(new Error('I dati del feedback non sono validi'));
        }*/

        try {
            const url = `${this.apiUrl}/inviaAvvisoDisponibilitaValutazione`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });

            // Lista nel body, altri parametri come query params
            const response = await this.client.post(url, listaUtenti, {
                params: {
                    idProgetto: idProgetto || null,
                    idSottoProgetto: idSottoProgetto || null
                }
            });
            
            return response.data;
        } catch (error) {
            console.error('Errore durante l\'invio del feedback:', error);
            throw error;
        }
    }


    /**
     * Invia i dati del feedback al server
     * @param {ErasmusFeedbackDTO} feedbackDTO
     * @returns {Promise}
     */
    async salvaFeedbackIntermedio(feedbackDTO) {
        /*if (!feedbackDTO.isValid()) {
            return Promise.reject(new Error('I dati del feedback non sono validi'));
        }*/

        try {
            const url = `${this.apiUrl}/salvaFeedbackIntermedio`;
            
            var token = localStorage.getItem('token');

            this.client = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });

            const response = await this.client.post(url, JSON.stringify(feedbackDTO));
            
            return response.data;
        } catch (error) {
            console.error('Errore durante l\'invio del feedback:', error);
            throw error;
        }
    }

}

export const formGradimentoService = new FormGradimentoService();